<template>  
    <v-select 
        :class="[ { 'is-invalid bd-danger': (classError) ? classError : false }]"
        label="sub-district"
        :value="address"
        :options="addressList"
        :filterable="false" 
        @search="onSearch"
        @input="$emit('setSelectedAddress', $event)"
    >
        <template slot="no-options">
            <span class="px-2">
                ค้นหาจากชื่อตำบล อำเภอ จังหวัด หรือรหัสไปรษณีย์ โดยไม่ต้องกรอกคำนำหน้า เช่น บางละมุง แล้วเลือกที่อยู่ที่ต้องการจากผลการค้นหา
            </span>
        </template>
        <template #selected-option-container="{ option }">
            <div class="vs__selected">
                {{ [option['sub-district'], option.district, option.province, option.postcode ].join(', ')}}
            </div>
        </template>
        <template v-slot:option="option">
            <span>
                {{ [option['sub-district'], option.district, option.province, option.postcode ].join(' >> ') }}
            </span>
        </template>
    </v-select> 
</template>

<script>
import { debounce } from "debounce";
import addressTH from "../AddressTH/addressTH.js";

export default {
    props:{
        address: Object,
        classError: Boolean
    },
    data(){
        return{
            addressList: [],
        }
    },
    methods:{
        onSearch(search, loading) {
            if(search.length > 2) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search: debounce((loading, search, vm) => {
            vm.addressList = vm.myFilter( search );
            loading(false);
        }, 350),
        myFilter(search){
            let temp = search.toLowerCase();
            return addressTH.filter( item => 
                item['sub-district'].toLowerCase().indexOf(temp) > -1 
                || item.district.toLowerCase().indexOf(temp) > -1
                || item.province.toLowerCase().indexOf(temp) > -1
                || String(item.postcode).indexOf(temp) > -1
            )
        },
    }
}
</script>
